import React, { useEffect, useState } from 'react';
import { PrimaryButton } from './PrimaryButton';
import { CHECKOUT_URL } from '../../utils/checkout';
export function StickyCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    let ticking = false;
    const handleScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        setVisible(window.scrollY > 640);
        ticking = false;
      });
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className={`fixed inset-x-0 bottom-0 z-40 border-t border-gris-claro bg-white/95 backdrop-blur-sm transition-transform duration-300 lg:hidden ${visible ? 'translate-y-0' : 'translate-y-full'}`} aria-hidden={!visible} data-id="element-303" data-mp="2nvnf5h3e3ihq">
      <div className="flex items-center justify-between gap-3 px-4 py-3" data-id="element-304" data-mp="2sw1m0vt98me6">
        <div data-id="element-305" data-mp="2stoxfzszrds5">
          <p className="font-heading text-sm font-semibold text-azul" data-id="element-306" data-mp="o0l0iesj62gp">17,99€</p>
          <p className="text-[11px] text-muted" data-id="element-307" data-mp="o2o11srb7dzo">Acceso inmediato</p>
        </div>
        <PrimaryButton size="md" showArrow={false} href={CHECKOUT_URL} data-id="element-308" data-mp="s2omvygqmrgr">
          Quiero Voley-Pro 360
        </PrimaryButton>
      </div>
    </div>;
}